import { type FragmentType, getFragmentData, graphql } from 'client/gql';
import dayjs from 'dayjs';
import { bookedBBBSlots } from '../utils/bookedBBBSlots';

const UseAvailableServicesForOrganizationFragmentDocument = graphql(`
  fragment UseAvailableServicesForOrganizationFields on Query {
    organizations(where: { uuid: $organizationUuid }) {
      uuid
      __typename
      licensedProducts {
        ... on Zoom {
          uuid
          __typename
        }
        ... on Bildungsplattform {
          uuid
          __typename
        }
        ... on Threema {
          uuid
          __typename
        }
        ... on ThreemaBroadcast {
          uuid
          __typename
        }
        ... on Nextcloud {
          uuid
          __typename
        }
        ... on BigBlueButton {
          uuid
          __typename
          allowRecording
          maxParticipantsPerMeeting
          organizationConnection {
            __typename
            edges {
              __typename
              properties {
                __typename
                version
                notAfter
                notBefore
              }
            }
          }
        }
      }
    }
  }
`);

export type AvailableService = {
  service: string;
  allowRecording: boolean;
  bookedConnections: number;
};

export const useAvailableServicesForOrganization = (
  query: FragmentType<typeof UseAvailableServicesForOrganizationFragmentDocument> | undefined,
) => {
  const fragment = getFragmentData(UseAvailableServicesForOrganizationFragmentDocument, query);
  const licensedProducts = fragment?.organizations[0]?.licensedProducts;

  return (
    licensedProducts
      ?.filter((p) => {
        if (p.__typename !== 'BigBlueButton') return true;
        const properties = p?.organizationConnection?.edges[0]?.properties;
        const now = dayjs();
        // service should only be available when license dates are valid
        return (
          dayjs(properties.notBefore) <= now &&
          (properties.notAfter === null || properties.notAfter === undefined || dayjs(properties.notAfter) > now)
        );
      })
      .map((p) => ({
        service: p.__typename,
        allowRecording: (p.__typename === 'BigBlueButton' && p.allowRecording) ?? false,
        maxParticipantsPerMeeting: p.__typename === 'BigBlueButton' ? p.maxParticipantsPerMeeting : 100,
        bookedConnections:
          p.__typename === 'BigBlueButton'
            ? bookedBBBSlots(p.organizationConnection?.edges[0]?.properties.version?.toLowerCase())
            : 0,
      })) ?? []
  ).filter((s) => ['BigBlueButton', 'Zoom'].includes(s.service));
};
